import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAgentAuth } from '../../contexts/AgentAuthContext';
import { Briefcase, Lock, Mail } from 'lucide-react';

const AgentLogin = () => {
  const { agentLogin, isAgentAuthenticated } = useAgentAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAgentAuthenticated()) return <Navigate to="/agent/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const r = await agentLogin(email, password);
    setLoading(false);
    if (r.success) navigate('/agent/dashboard');
    else setError(r.message || 'Errore');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 via-fuchsia-50 to-white p-6" data-testid="agent-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br from-purple-600 to-fuchsia-500 flex items-center justify-center text-white shadow-lg">
            <Briefcase className="w-7 h-7" />
          </div>
          <h1 className="mt-4 text-2xl font-bold text-gray-900">Portale Agente</h1>
          <p className="text-sm text-gray-600">Accedi al tuo portafoglio clienti IlTuoAmaro</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl border border-purple-100 p-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                data-testid="agent-login-email" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                data-testid="agent-login-password" />
            </div>
          </div>
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-md px-3 py-2 text-sm text-red-700">{error}</div>
          )}
          <button type="submit" disabled={loading}
            data-testid="agent-login-submit"
            className="w-full py-2.5 bg-gradient-to-r from-purple-600 to-fuchsia-500 text-white font-semibold rounded-md hover:opacity-90 disabled:opacity-50">
            {loading ? 'Accesso in corso…' : 'Accedi al portale'}
          </button>
          <p className="text-[11px] text-center text-gray-500">
            Sei un cliente? <a href="/login" className="text-purple-600 hover:underline">Login clienti</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default AgentLogin;
